import {APP_INITIALIZER, ApplicationConfig, isDevMode, Provider} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {KeycloakBearerInterceptor, KeycloakService} from "keycloak-angular";
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import localeKk from '@angular/common/locales/kk';
import { LocaleService, DEFAULT_LANG } from './services/locale.service';

// Month and weekday names for formatDate(); en is built in.
registerLocaleData(localeRu);
registerLocaleData(localeKk);

const LocaleInitializerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: (locale: LocaleService) => () => locale.init(),
  multi: true,
  deps: [LocaleService]
};

const KeycloakBearerInterceptorProvider: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: KeycloakBearerInterceptor,
  multi: true
};

// Provider for Keycloak Initialization
const KeycloakInitializerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeKeycloak,
  multi: true,
  deps: [KeycloakService]
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(), // required animations providers
    provideToastr({
      preventDuplicates: true}), // Toastr providers
    provideRouter(routes), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideHttpClient(withInterceptorsFromDi()), // Provides HttpClient with interceptors
    KeycloakBearerInterceptorProvider,
    KeycloakInitializerProvider, // Initializes Keycloak
    KeycloakBearerInterceptorProvider, // Provides Keycloak Bearer Interceptor
    KeycloakService, provideAnimationsAsync(), provideAnimationsAsync(), // Service for Keycloak
    provideTranslateService({ fallbackLang: DEFAULT_LANG }),
    // useHttpBackend bypasses the interceptor chain: the bundles are static assets on our
    // own origin and must load even before Keycloak has a token to attach.
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json', useHttpBackend: true }),
    LocaleInitializerProvider,
  ]
}

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      // Configuration details for Keycloak
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      // Options for Keycloak initialization
      initOptions: {
        onLoad: 'login-required', // Action to take on load
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html', // URI for silent SSO checks
        silentCheckSsoFallback: true
      },
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer',
    });
}
